import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"16\" height=\"16\" fill=\"url(#paint0_radial_8069_78)\" rx=\"4\"></rect><path fill=\"#fff\" d=\"m10.285 4.48 3.215-.288-2.43 6.847-2.167.194 1.493-4.206-2.66 4.31-1.834.165.258-4.095-1.493 4.206-2.167.195L4.93 4.96 7.843 4.7 7.65 8.756z\"></path><defs><radialGradient id=\"paint0_radial_8069_78\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"rotate(130.469 7.368 3.185)scale(21.7054)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#FFA599\"></stop><stop offset=\".282\" stop-color=\"#FF7866\"></stop><stop offset=\".714\" stop-color=\"#FF462D\"></stop><stop offset=\"1\" stop-color=\"#FFA599\"></stop></radialGradient></defs>", 3)
  ])))
}
export default { render: render }